// extracted by mini-css-extract-plugin
module.exports = {"loader":"_2oKXn","load6":"PAXE2","medium":"_1fJWD","mini":"_38OQ5"};